'use client';

import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import styles from './Backdrop.module.css';
import { BackdropComponentProps } from './types';

const Backdrop = ({ children, className, onClick, ...rest }: PropsWithChildren<BackdropComponentProps>) => (
  <div data-testid={'backdrop'} className={clsx(styles.BackDrop, className)} aria-hidden="true" onClick={onClick} {...rest}>
    {children}
  </div>
);

export default Backdrop;
